module.exports = __webpack_public_path__ + "img/freelance-2.e83ee62d.png";